import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  UpdateBuildingSupervisors as UpdateBuildingSupervisorsGenerated,
  UpdateBuildingSupervisorsVariables as UpdateBuildingSupervisorsVariablesGenerated,
} from "core/queries/__generated__/UpdateBuildingSupervisors";

export interface UpdateBuildingSupervisorsResponse
  extends UpdateBuildingSupervisorsGenerated {}
export interface UpdateBuildingSupervisorsVariables
  extends UpdateBuildingSupervisorsVariablesGenerated {}

export const updateBuildingSupervisors = gql`
  mutation UpdateBuildingSupervisors(
    $buildingId: String!
    $addedSupervisors: [ID!]
    $removedSupervisors: [ID!]
  ) {
    updateBuildingSupervisors(
      buildingId: $buildingId
      addedSupervisors: $addedSupervisors
      removedSupervisors: $removedSupervisors
    ) {
      building {
        id
      }
    }
  }
`;

interface UseUpdateBuildingSupervisorsQueryOptions {
  refetchQueries?: string[];
  awaitRefetchQueries?: boolean;
  onCompleted?: (data: UpdateBuildingSupervisorsResponse) => void;
}
export const useUpdateBuildingSupervisors = ({
  refetchQueries = [],
  awaitRefetchQueries,
  onCompleted,
}: UseUpdateBuildingSupervisorsQueryOptions) =>
  useMutation<
    UpdateBuildingSupervisorsResponse,
    UpdateBuildingSupervisorsVariables
  >(updateBuildingSupervisors, {
    refetchQueries,
    awaitRefetchQueries,
    onCompleted,
  });
